import { ResourceOptions } from 'react-admin';
import { FaRegUser } from 'react-icons/fa';
import { Resources } from '../resource';
import ListComponent from './List';
import ShowComponent from './Show';

export const list = ListComponent;
export const show = ShowComponent;

export const name = Resources.userInfo;
export const icon = FaRegUser;
export const options: ResourceOptions = {
  label: 'resource.userInfo',
};
